import React from 'react';
import { NavLink } from 'react-router-dom';
import cl from './Cart.module.css';
import { getRandomNumber } from '../Home/Home';

const Cart = (props) => {
  const { cartItems, onAdd, onRemove } = props;

  const subTotalPrice = cartItems.reduce((a, c) => a + c.oldPrice * c.qty, 0);
  const totalPrice = cartItems.reduce(
    (a, c) => a + ((c.oldPrice * (100 - c.discount)) / 100) * c.qty,
    0
  );
  const discountPrice = subTotalPrice - totalPrice;
  return (
    <section className={cl.main_cart}>
      <h2 className={cl.header}>Elementos en el Carrito</h2>
      <div
        style={{
          width: '100%',
          height: '25px',
          backgroundColor: 'var(--primary)',
          marginBottom: '40px',
        }}
      ></div>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '20px',
          justifyContent: 'center',
        }}
      >
        {cartItems.length === 0 && (
          <div className={cl.header_empty}>Carrito Vacío</div>
        )}
        {cartItems.map((item) => (
          <div key={getRandomNumber(1, 10000)} className={cl.row}>
            <div className={cl.row_img_container}>
              <img src={item.images ? item.images[0] : ''} alt="" />
            </div>
            <div className={cl.name}>{item.name}</div>
            <div className={cl.buttons}>
              <button onClick={() => onAdd(item)} className={cl.add}>
                Agregar
              </button>
              <button onClick={() => onRemove(item)} className={cl.remove}>
                Eliminar
              </button>
            </div>
            <div className={cl.amount}>
              {item.qty} unidad x {item.currency}
              {((item.oldPrice * (100 - item.discount)) / 100).toFixed(2)}
            </div>
          </div>
        ))}
      </div>
      {cartItems.length !== 0 && (
        <>
          <hr></hr>
          <div>
            <div className={cl.price}>
              <div>Subtotal</div>
              <div>
                {cartItems[0].currency}
                {subTotalPrice.toFixed(2)}
              </div>
            </div>
            <div className={cl.price}>
              <div>Descuento</div>
              <div>
                -{cartItems[0].currency}
                {discountPrice.toFixed(2)}
              </div>
            </div>
            <div className={cl.price_total}>
              <div>Precio Total</div>
              <div>
                {cartItems[0].currency}
                {totalPrice.toFixed(2)}
              </div>
            </div>
          </div>
          <NavLink className={cl.button_checkout} to="/checkout">
            PROCEDE AL PAGO
          </NavLink>
        </>
      )}
    </section>
  );
};

export default Cart;
